
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BtnIcon',
  props: {
    iconName: {
      type: String,
      default: ''
    }
  }
})
